export enum HoardingLightEnum {
    F_L = "FL",
    B_L = "BL",
    N_L = "NL",
    // A_L = "AL",
    VARIOUS = "Various"
}
